export const FORM_FIELDS = {
  EMAIL: {
    name: 'email',
    label: 'Email',
  } as const,
};
